/* ################################################################### */
/* FUNCTION (STICKY FOOTER) ########################################## */
/* ################################################################### */
function stickyFooter()
{
	jQuery('#footer').attr('style', '');

	var h_body    = jQuery('body').height();
		h_wrapper = jQuery('#wrapper').outerHeight(true);

	if(h_body > h_wrapper)
		jQuery('#footer').css('margin-top', h_body - h_wrapper);
}

